// Utility function for selecting HTMLElement nodes
// Perform the same functionality as (Document | Element).querySelectorAll, but filter the results to only the nodes that extend from HTMLElement
// - return HTMLElement[] instead of NodeList;
export const queryAllHtmlElement = (root: Document | Element, selector: string): HTMLElement[] => {
	return [...root.querySelectorAll(selector)].filter(el => el instanceof HTMLElement);
};
